import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserInfoProps {
  token?: string;
  country_code?: number;
  createdAt?: string;
  email?: string;
  id?: string;
  name?: string;
  phone?: string;
  updatedAt?: string;
  username?: string;
  smart_account?: string;
  lat?: number;
  long?: number;
  ip?: string;
}

const initialState: UserInfoProps = {
  token: "",
};

const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    getInfo: (state) => {
      return state;
    },
    saveInfo: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    clearInfo: (state) => {
      state = initialState;
      return state;
    },
  },
});

const logOut = createAction("user/logOut");

export const { saveInfo, getInfo, clearInfo } = userSlice.actions;

export { logOut };

export default userSlice.reducer;
